import { handleSendInquiry } from "../common";
const footer1_Init = () => {
  handleSendInquiry({ formId: "#footer-1-form", trigger: "#footer-1-submit" });
};

export default footer1_Init;
